import { Anchor, Layer } from 'grommet';
import { LinkItem } from 'modules/root/components/LinkItem';
import React, { useState } from 'react';
import { connect } from 'rxbeach/react';
import { State } from 'types';
import Login from './components/Login';
import { auth$ } from './stream/auth$';
import { User } from './types';

interface AuthProps {
  user: User | null;
  state: State;
}

const Auth = ({ user, state }: AuthProps) => {
  const [show, setShow] = useState(false);
  return (
    <>
      {user && (
        <LinkItem
          route="/admin"
          color="#8b91e3"
          size="small"
          label={user.name}
        />
      )}

      {!user && (
        <>
          <Anchor
            color="#8b91e3"
            size="small"
            label="Logg inn"
            onClick={() => setShow(true)}
          />
          {show && (
            <Layer
              onEsc={() => setShow(false)}
              onClickOutside={() => setShow(false)}
            >
              <Login close={() => setShow(false)} state={state} />
            </Layer>
          )}
        </>
      )}
    </>
  );
};

export default connect(Auth, auth$);
